import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect, useRef } from 'react';

import LinkBar from '../components/linkBar';
import { PraxisTherapists } from '../containers/praxisTherapists';
import { PraxisWhy } from '../containers/praxisWhy';
import useScrollTo from '../hooks/useScrollTo';
import { MainContent } from '../styles';
import { GraphQLData } from '../types';
import { getLocalizationObj } from '../utilities/getLocalizationObj';

interface PraxisProps {
  data: GraphQLData;
  location: any;
}

export const PraxisTemplateMain = ({ location, data }: PraxisProps) => {
  const { t } = useTranslation();

  const linkBarItems = [
    {
      title: t('our promises'),
      to: `/${t('practice')}/#promises`,
    },
    {
      title: t('team'),
      to: `/${t('practice')}/#team`,
    },
    // {
    //   title: 'Erster Besuch',
    //   to: '/praxis/#visit',
    // },
  ];

  const item0ref = useRef();
  const item1ref = useRef();
  const item2ref = useRef();

  // handle scroll to element
  const scrollTo = useScrollTo();
  useEffect(() => {
    const area = location.hash.slice(1);
    if (area === 'promises' && item0ref) scrollTo(item0ref);
    if (area === 'team' && item1ref) scrollTo(item1ref);
    // if (area === 'visit' && visitRef) scrollTo(visitRef);
  }, [location.hash, scrollTo]);

  // const { t } = useTranslation();
  const { praxi, therapists } = data.strapi || {};
  const { therapistDescription, warumCarousel, whyTitle, therapistTitle } =
    getLocalizationObj(praxi) || {};

  return (
    <MainContent css={{ pt: ['6', undefined, '6'] }}>
      <LinkBar items={linkBarItems} refs={[item0ref, item1ref]} />
      <PraxisWhy
        ref={item0ref}
        warumCarousel={warumCarousel}
        whyTitle={whyTitle}
      />
      <PraxisTherapists
        ref={item1ref}
        {...{
          therapistDescription,
          therapists: getLocalizationObj(therapists),
          therapistTitle,
        }}
      />
    </MainContent>
  );
};
